import AddRequestHeader from '../AddRequestHeader';
import FormField from './FormField';
import RequestOverviewInput from './RequestOverviewInput';
import RequestOverviewTextArea from './RequestOverviewTextArea';

interface Props {
    isEditMode?: boolean;
}

export default function RequestOverview({ isEditMode = false }: Props) {
    return (
        <>
            <AddRequestHeader title="Basic Information" description="Add a title and short description to summarize what your buyer is looking for." />

            <div className="lg:space-y-10 space-y-5 mt-5">
                <div className="space-y-3">
                    <FormField htmlFor="title" label="Request Title" description="A short, descriptive title for easy reference" isEditMode={isEditMode} />
                    <RequestOverviewInput isEditMode={isEditMode} />
                </div>
                <div className="border border-gray-100 mx-1.5" />

                <div className="lg:space-y-3 space-y-2">
                    <FormField
                        htmlFor="description"
                        label="Request Description"
                        description="Provide a description with any relevant details that the buyer is looking for in their new property"
                        isEditMode={isEditMode}
                    />
                    <RequestOverviewTextArea isEditMode={isEditMode} />
                </div>
            </div>
        </>
    );
}
